<template>
  <div class="modal__payment-discounts">
    <div class="modal__payment-discounts__header">
      <div class="flex flex-wrap">
        <div class="w-full md:w-1/2">
          <h5 class="font-bold mb-8">{{ $t('selectCouponOrCode') }}</h5>
          <div class="modal__payment-discounts__discount-code w-full">
            <label class="couponCode input input-lg input-buttons w-full" :class="{'couponCode--error': codeStatus === STATUS_FAILED}" for="couponCode">
              <input name="couponCode" class="couponCode__input w-full" v-model="couponCode" type="text" :placeholder="$t('insertCouponCode')" :disabled="isCheckingCode">
              <button class="input-btn couponCode__btn fixed-loading flex-no-shrink" @click="submitCode" :disabled="isCheckingCode" v-loading="isCheckingCode" element-loading-spinner="owl-arrow-reload animate-spin">
                <!-- <template v-if="isCheckingCode">驗證中</template> -->
                <template>{{ $t('verify') }}</template>
              </button>
            </label>
          </div>
        </div>
        <div v-if="codeStatus && !isCheckingCode" class="my-16 md: my-0 md:my-8 md:border-l md:border-grey-light md:ml-16 md:pl-16 flex">
            <div>
              <i :class="{ 'owl-status-check bg-green-dark': codeStatus === STATUS_DONE, 'owl-status-error bg-red': codeStatus === STATUS_FAILED }" class="text-sm text-white rounded-full mr-8"></i>
            </div>
            <div>
              <div :class="{ 'text-green-dark': codeStatus === STATUS_DONE, 'text-red': codeStatus === STATUS_FAILED }" class="text-md mb-8 max-w-xs">
                <span v-if="codeStatus === STATUS_DONE">{{ $t('exchangeCompletion') }}</span>
                <span v-else>{{ codeErrorMsg }}</span>
              </div>
              <div class="text-sm text-grey-dark">
                <span v-if="codeStatus === STATUS_DONE">{{ $t('couponOnlyUsedOnApp') }}</span>
                <span v-else>{{ $t('pleaseInsertCouponAgain') }}</span>
              </div>
            </div>
        </div>
      </div>
    </div>
    <div class="modal__payment-discounts__body" v-loading="isLoadingCoupons">
      <template v-if="premiumCoupon">
        <p class="font-bold text-xl px-8 py-16 w-full">{{ $t('discountDialog.usingPremium') }}</p>
        <label class="modal__payment-discounts__card w-full sm:w-1/2" :class="showStackableCouponClear || !selectedCoupon ? 'activate' : 'disable'">
          <div class="modal__payment-discounts__card__wrap">
            <div class="modal__payment-discounts__card__header">
              <div>
                <div class="text-lg font-bold mb-4 flex items-center text-premium-dark">
                  <div class="font-semibold flex items-center">
                    {{ (showStackableCouponClear || !selectedCoupon) ? $t('discountDialog.using') : '' }}{{ premiumCoupon.name }}
                    <premiumImage type="icon" class="ml-4" style="width: 20px; height: 20px" />
                  </div>
                </div>
                <div class="text-grey-darkest mt-8">
                  {{ $t('premium.discount.login[0]') }}
                  {{ $t('premium.discount.login[1]', {currency: this['user/currencySign'], value: convertPremiumDiscount}) }}
                </div>
              </div>
            </div>
          </div>
        </label>
        <div v-if="stackableCoupons.length > 0" class="flex justify-between items-center mt-24 mb-16 w-full">
          <p class="text-grey-darker font-bold px-8">{{ $t('discountDialog.stackableWithPremium') }}</p>
          <span v-if="showStackableCouponClear" class="text-blue-light font-bold cursor-pointer" style="min-width: 32px" @click="clearCoupon">{{ $t('clear') }}</span>
        </div>
        <label
          v-for="coupon in stackableCoupons"
          class="modal__payment-discounts__card w-full sm:w-1/2"
          :class="{'activate': selectedCoupon && selectedCoupon.id === coupon.id, 'disable': coupon.platform === COUPON_PLATFORM_APP }" :key="coupon.id">
          <div class="modal__payment-discounts__card__wrap">
            <div class="modal__payment-discounts__card__header">
              <div class="flex items-start">
                <div class="owl-radio-wrap">
                  <input v-model="selectedCoupon" type="radio" :value="coupon" :name="'coupon-' + coupon.id">
                  <div class="owl-radio"></div>
                </div>
                <div class="text-md font-bold text-grey-darker mr-16 leading-normal">{{ coupon.name }}</div>
              </div>
              <div class="text-lg font-bold text-blue-light">
                <span v-if="coupon.discountUnit === 'price'" class="leading-normal">
                  <span v-if="isCurrencyConvert">{{ $t('priceAbout') }} </span>
                  {{ currencySign }}{{ Number(coupon.discountValue) | currencyConvert({inputCurrency: coupon.currency}) }}
                </span>
                <span v-if="coupon.discountUnit === 'percent'" class="leading-normal">
                  {{ Number(coupon.discountValue) | toPercentage }}%
                </span>
              </div>
            </div>
            <div class="modal__payment-discounts__card__body">
              <p v-if="coupon.platform === COUPON_PLATFORM_APP" class="flex items-center font-bold text-blue-light">
                <img class="mr-8" height="24px" width="24px" src="@/assets/images/icon-app-only.svg" />
                <span class="text-sm">{{ $t('usedForApp') }}</span>
              </p>
              <p class="mb-8 mt-8 text-sm">{{ $t('limit') }}
                <!-- {{ +coupon.minPrice }} <small>{{ coupon.currency }}</small> {{ $t('uponToCanUse') }} -->
                {{ currencySign }}{{ Number(coupon.minPrice) | currencyConvert({inputCurrency: coupon.currency}) }} {{ $t('uponToCanUse') }}
              </p>
              <div class="flex justify-between items-start md:items-center flex-col md:flex-row">
                <div class="text-sm text-grey-dark">{{ $t('expiredDate') }}: {{ coupon.expiryAt | toDate('YYYY-MM-DD HH:mm:ss') }}</div>
                <button
                  class="btn p-0 md:btn-sm btn-text btn-grey-dark text-sm mt-16 md:mt-0"
                  @click="onCouponDetailClick(coupon)">
                  <span>{{ $t('more') }} </span>
                  <i class="owl-arrow-top-right"></i>
                </button>
              </div>
            </div>
          </div>
        </label>
        <div class="w-full pt-24 px-8" />
      </template>
      <div
        v-if="!isLoadingCoupons && hasCoupons"
        class="flex flex-col justify-center items-center text-grey-dark w-full mx-16 my-24 border-1 border-grey-lighter py-24 rounded">
        <figure class="no-coupon-img mb-16">
          <img src="@/assets/images/points/no-coupons.png" />
        </figure>
        <!-- <i class="text-orange text-lg owl-status-triangle-warning"></i> -->
        <span class="text-lg font-bold text-grey-darkest">{{ $t('noCoupon') }}</span>
      </div>
      <!-- MEMO Premium 會員區塊 -->
      <template v-for="coupon in coupons">
        <div v-if="coupon.code === 'PREMIUM_COUPON'" class="border-b border-grey-lightest pb-16 mb-16 w-full" :key="coupon.id">
          <label class="modal__payment-discounts__card w-full sm:w-1/2" :class="{'activate': selectedCoupon && selectedCoupon.id === coupon.id }">
            <div class="modal__payment-discounts__card__wrap">
              <div class="modal__payment-discounts__card__header">
                <div class="flex items-start">
                  <div class="owl-radio-wrap">
                    <input v-model="selectedCoupon" type="radio" :value="coupon" :name="'coupon-' + coupon.id">
                    <div class="owl-radio"></div>
                  </div>
                  <div>
                    <div class="text-xl font-bold mb-4 flex items-center text-premium">
                      <div class="mr-8">{{ coupon.name }}</div>
                      <premiumImage type="icon" />
                    </div>
                    <div class="text-grey-darkest">{{ $t('premium.discount.login[0]') }} {{ $t('premium.discount.login[1]', {currency: 'NT$', value: $options.filters.toCurrency(order.premiumDiscount)}) }}</div>
                  </div>
                </div>
              </div>
            </div>
          </label>
        </div>
      </template>
      <!-- 一般的coupon -->
      <div v-if="coupons.length > 0" class="pt-24 border-t border-grey-lightest w-full flex items-center justify-between">
        <p class="font-bold text-xl px-8 py-16">{{ $t('discountDialog.general') }}</p>
        <span v-if="showNormalCouponClear && !isPremium" class="text-blue-light font-bold cursor-pointer" style="min-width: 32px" @click="clearCoupon">{{ $t('clear') }}</span>
      </div>
      <div v-if="showNormalCouponClear && premiumCoupon" class="flex justify-between w-full text-red mb-8 px-8">
        <div class="flex">
          <i class="owl-status-triangle-warning"></i>
          <p>{{ $t('discountDialog.unstackableWithPremium') }}</p>
        </div>
        <span v-if="showNormalCouponClear" class="text-blue-light font-bold cursor-pointer" style="min-width: 32px" @click="clearCoupon">{{ $t('clear') }}</span>
      </div>
      <template v-for="coupon in coupons">
        <label
          v-if="coupon.code !== 'PREMIUM_COUPON'"
          class="modal__payment-discounts__card w-full sm:w-1/2"
          :class="{'activate': selectedCoupon && selectedCoupon.id === coupon.id, 'disable': coupon.platform === COUPON_PLATFORM_APP }" :key="coupon.id">
          <div class="modal__payment-discounts__card__wrap">
            <div class="modal__payment-discounts__card__header">
              <div class="flex items-start">
                <div class="owl-radio-wrap">
                  <input v-model="selectedCoupon" type="radio" :value="coupon" :name="'coupon-' + coupon.id">
                  <div class="owl-radio"></div>
                </div>
                <div class="text-md font-bold text-grey-darker mr-16 leading-normal">{{ coupon.name }}</div>
              </div>
              <div class="text-lg font-bold text-blue-light">
                <!-- <span v-if="coupon.discountUnit === 'price'" class="leading-normal">
                  <span v-if="isCurrencyConvert">{{ $t('priceAbout') }} </span>
                  {{ currencySign }}{{ Number(coupon.discountValue) | currencyConvert({inputCurrency: coupon.currency}) }}
                </span>
                <span v-if="coupon.discountUnit === 'percent'" class="leading-normal">
                  {{ Number(coupon.discountValue) | toPercentage }}% OFF
                </span> -->
                {{ displayCouponCount(coupon) }}
              </div>
            </div>
            <div class="modal__payment-discounts__card__body">
              <p v-if="coupon.platform === COUPON_PLATFORM_APP" class="flex items-center font-bold text-blue-light">
                <img class="mr-8" height="24px" width="24px" src="@/assets/images/icon-app-only.svg" />
                <span class="text-sm">{{ $t('usedForApp') }}</span>
              </p>
              <p class="mb-8 mt-8 text-sm">{{ $t('limit') }}
                <!-- {{ +coupon.minPrice }} <small>{{ coupon.currency }}</small> {{ $t('uponToCanUse') }} -->
                {{ currencySign }}{{ Number(coupon.minPrice) | currencyConvert({inputCurrency: coupon.currency}) }} {{ $t('uponToCanUse') }}
              </p>
              <div class="flex justify-between items-start md:items-center flex-col md:flex-row">
                <div class="text-sm text-grey-dark">{{ $t('expiredDate') }}: {{ coupon.expiryAt  | toDate('YYYY-MM-DD HH:mm:ss') }}</div>
                <button
                  class="btn p-0 md:btn-sm btn-text btn-grey-dark text-sm mt-16 md:mt-0"
                  @click="onCouponDetailClick(coupon)">
                  <span>{{ $t('more') }} </span>
                  <i class="owl-arrow-top-right"></i>
                </button>
              </div>
            </div>
          </div>
        </label>
      </template>
      <!-- MEMO End of Premium 會員區塊 -->
    </div>
    <div class="modal__payment-discounts__footer flex justify-end">
      <button
        class="btn btn-text btn-grey w-full sm:w-auto"
        @click="onCancel">
        {{ $t('cancel') }}
      </button>
      <button
        class="btn btn-solid btn-blue ml-16 w-full sm:w-auto"
        @click="onSave">
        {{ $t('confirm') }}
      </button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
// import loadingBlock from '@/components/loadingBlock'
import numeral from 'numeral'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import fullPageModal from '@/components/modals/fullPageModal'
import couponDetail from '@/components/couponDetail'
import responseMessage from '@/utils/responseMessage'

const COUPON_PLATFORM_APP = 'app'

const STATUS_DONE = 'done'
const STATUS_FAILED = 'failed'

export default {
  name: 'PaymentDiscounts',
  props: {
    onModalCancel: {
      type: Function
    }
  },
  components: {
    // loadingBlock
  },
  data () {
    return {
      COUPON_PLATFORM_APP,
      STATUS_DONE,
      STATUS_FAILED,
      isCheckingCode: false,
      codeStatus: null,
      codeErrorMsg: null,
      couponCode: null,
      type: 'code',
      code: null,
      coupon: null,
      selectedCoupon: null,
      isLoadingCoupons: true,
      stackableCoupons: [], // 可疊加
      coupons: [], // 不可疊加,
      premiumCoupon: null
    }
  },
  filters: {
    toPercentage: function (val) {
      return 100 - val * 100
    }
  },
  computed: {
    ...mapGetters({
      order: 'order/order',
      isPremium: 'user/isPremium',
      'order/order': 'order/order',
      'order/selectedCoupon': 'order/selectedCoupon',
      'order/premiumCoupon': 'order/premiumCoupon',
      'user/currencySign': 'user/currencySign',
      'user/selectedCurrency': 'user/selectedCurrency'
    }),
    hasCoupons: function () {
      return (_.isEmpty(this.coupons) && _.isEmpty(this.stackableCoupons))
    },
    showStackableCouponClear: function () {
      return this.selectedCoupon && this.selectedCoupon.isStackable
    },
    showNormalCouponClear: function () {
      return this.selectedCoupon && !this.selectedCoupon.isStackable
    },
    isCurrencyConvert: function () {
      return this['order/order'].currency !== this['user/selectedCurrency']
    },
    currencySign: function () {
      return this['user/currencySign']
    },
    hotelCurrency: function () {
      return this['order/order'].currency
    },
    convertPremiumDiscount: function () {
      return this.$options.filters.currencyConvert(this['order/order'].premiumDiscount, { inputCurrency: this['order/order'].currency })
    }
  },
  methods: {
    ...mapActions([
      'order/orderCoupons',
      'order/onSaveDiscount',
      'order/setCouponToUpdate',
      'user/addCoupons',
      'user/getNight',
    ]),
    ...mapMutations([
      'order/CLEAR_COUPON'
    ]),
    displayCouponCount: function (coupon) {
      if (coupon.discountUnit === 'percent') {
        return numeral((Number(1 - coupon.discountValue) * 100)).format('0[.]00') + '% OFF'
      } else {
        const prefix = this.isCurrencyConvert ? this.$t('priceAbout') + ' ' : ''
        if (this.isCurrencyConvert) {
          return prefix + this.currencySign + this.$options.filters.currencyConvert(+coupon.discountValue, { inputCurrency: coupon.currency })
        } else {
          return prefix + this.currencySign + this.$options.filters.toCurrency(this.$options.filters.currencyConvert(+coupon.discountValue, { inputCurrency: coupon.currency }))
        }
      }
    },
    submitCode: function () {
      if (this.couponCode) {
        this.isCheckingCode = true
        this.codeStatus = null
        this['order/orderCoupons']({
          orderSerial: this['order/order'].orderSerial,
          code: this.couponCode
        }).then(res => {
          this.isCheckingCode = false
          if (res.status === 200) {
            if (this.isPremium) {
              this.coupons = res.data.canUseCoupons.filter(e => e.isStackable === false)
              this.stackableCoupons = res.data.canUseCoupons.filter(e => e.isStackable === true)
            } else {
              this.coupons = res.data.canUseCoupons
            }
            this.codeErrorMsg = null
            this.isLoadingCoupons = false
            this.selectedCoupon = res.data.coupon
            this.premiumCoupon = res.data.premiumCoupon
            this['order/onSaveDiscount'](this.selectedCoupon)
            this['order/setCouponToUpdate']()
            this.$emit('close')
          } else {
            if (res.status === 70111) {
              this.codeStatus = STATUS_DONE
              this.getCouponList()
            } else if (res.status === 70114) {
              this.codeStatus = STATUS_FAILED
              this.codeErrorMsg = res.msg
            } else {
              this.codeStatus = STATUS_FAILED
              this.codeErrorMsg = responseMessage('postOrder', res.status)
            }
          }
        })
      }
    },
    onCancel: function () {
      this.onModalCancel()
      this.$emit('close')
    },
    onSave: function () {
      if (this.selectedCoupon) {
        this['order/onSaveDiscount'](this.selectedCoupon)
        this['order/setCouponToUpdate']()
      } else {
        this['order/CLEAR_COUPON']()
        this.onModalCancel()
      }
      this.$emit('close')
    },
    onCouponDetailClick: function (coupon) {
      this.$modal.show(fullPageModal,
        {
          // 輸入內容
          context: couponDetail,
          data: {
            coupon
          }
        },
        {
          adaptive: true,
          name: 'couponDetail',
          clickToClose: true,
          height: 'auto',
          width: '95%',
          minWidth: 350,
          maxWidth: 600,
          scrollable: true
        }
      )
    },
    getCouponList: function () {
      this.isLoadingCoupons = true
      this['order/orderCoupons']({
        orderSerial: this['order/order'].orderSerial
      }).then(res => {
        if (res.status === 200) {
          // const firstCanUseCoupon = _.find(res.data.canUseCoupons, coupon => { return coupon.platform !== COUPON_PLATFORM_APP })

          if (this.isPremium) {
            this.coupons = res.data.canUseCoupons.filter(e => e.isStackable === false)
            this.stackableCoupons = res.data.canUseCoupons.filter(e => e.isStackable === true)
          } else {
            this.coupons = res.data.canUseCoupons
          }
          this.isLoadingCoupons = false
          this.premiumCoupon = res.data.premiumCoupon
          if (!_.isEmpty(this['order/selectedCoupon'])) {
            const coupon = _.find(res.data.canUseCoupons, coupon => {
              return coupon.id === this['order/selectedCoupon'].id
            })
            if (coupon) {
              this.selectedCoupon = coupon
            }
          }
        } else {
          this.isLoadingCoupons = false
          console.error('[優惠卷錯誤]', res)
        }
      })
    },
    clearCoupon: function () {
      window.dataLayer.push({
        event: 'order_coupon_clear',
      })
      this.selectedCoupon = null
    }
  },
  mounted () {
    this.getCouponList()
  },
  watch: {
    couponCode: {
      handler: function (val, oldVal) {
        this.codeStatus = null
      }
    }
    // type: {
    //   handler: function (val, oldVal) {
    //     if (val !== oldVal && val === 'coupon' && !this.coupon) {
    //       this.onCouponDetailClick()
    //     }
    //   }
    // }
  }
}
</script>

<style lang="sass" scoped>
  .modal__payment-discounts
    @apply flex flex-col
    max-height: calc(100vh - 16px)
    &__header
      @apply p-16
      box-shadow: 0 15px 30px -10px rgba(92, 101, 107, 0.15)
      .couponCode
        @apply flex
        &__input[disabled], &__btn[disabled]
          @apply opacity-50 cursor-not-allowed
        &.couponCode--error
          .couponCode__input
            @apply border-l border-t border-b border-red bg-red-lightest
          .couponCode__btn
            @apply border-r border-t border-b border-red
    &__body
      @apply p-16 flex flex-wrap flex-1 overflow-y-auto
      min-height: 80px
      .no-coupon-img
        width: 115px
        height: 100px
        img
          @apply w-full
    &__footer
      @apply text-right
      @apply p-16
      box-shadow: 0 -15px 30px -10px rgba(92, 101, 107, 0.15)
    &__card
      @apply flex cursor-pointer
      &:hover, &.activate
        .modal__payment-discounts__card__wrap
          @apply shadow-md
      &.activate
        .modal__payment-discounts__card
          &__wrap
            @apply border-2 border-blue-light
          &__header
            @apply flex justify-between items-center border-b border-grey-lighter p-16
          &__body
            @apply p-16
      &.disable
        cursor: not-allowed
        opacity: .6
        pointer-events: none
      &__wrap
        @apply border border-grey-lighter flex flex-col flex-1 m-8 bg-white rounded
      &__header
        @apply flex justify-between items-center border-b border-grey-lighter p-16
      &__body
        @apply flex flex-col flex-1 justify-between p-16
</style>
